import { useEvents } from '../contexts/EventContext';

/**
 * The UI term for the attendee grouping tag on the SELECTED event.
 *
 * The underlying data field is `GuestRecord.chapterAffiliation` (unchanged),
 * but each event can present it with its own word — "Chapter" for a reunion,
 * "Company" for a conference, "Family" for a party, etc. Falls back to
 * "Affiliation" when no event is selected or the label is unset.
 *
 * Returns both the singular label and a lowercase form for inline sentences.
 */
export function useAffiliationLabel(): { label: string; lower: string } {
  const { selectedEvent } = useEvents();
  const label = (selectedEvent?.affiliationLabel || '').trim() || 'Affiliation';
  return { label, lower: label.toLowerCase() };
}
